import { EOnboaringFormStep } from '@constants';

type ValidationConfig = {
  requiredFields: (string | string[])[];
};

type StepValidationConfigParams = {
  isPce?: boolean;
};

export const getStepValidationConfig = (
  params?: StepValidationConfigParams
): Record<EOnboaringFormStep, ValidationConfig> => {
  const { isPce } = params || {};

  return {
    [EOnboaringFormStep.COMPLETE_PROFILE]: {
      requiredFields: ['name', 'lastName', 'phone', 'legalId', 'birthday', 'country']
    },
    [EOnboaringFormStep.COMPLETE_PROFILE_FP]: {
      requiredFields: [
        'name',
        'lastName',
        'secondLastName',
        'phone',
        'legalIdType',
        'legalId',
        'birthday',
        ['userInfo', 'nationality'],
        ['userInfo', 'gender'],
        ['userInfo', 'countryBirth'],
        ['userInfo', 'birthProvince'],
        ['userInfo', 'birthMunicipality'],
        ['userInfo', 'birthLocality'],
        ['userInfo', 'birthLocalityForeign'],
        ['userInfo', 'province'],
        ['userInfo', 'city'],
        ['userInfo', 'residenceLocality'],
        ['userInfo', 'streetType']
      ]
    },
    [EOnboaringFormStep.YOU_HAVE_MASTER_DEGREE]: {
      requiredFields: [['userInfo', 'oposUserInfo', 'hasMasterDegree']]
    },
    [EOnboaringFormStep.DEFINE_YOUR_GOAL]: {
      requiredFields: [
        ['userInfo', isPce ? 'pceUserInfo' : 'uniUserInfo', 'studyBranch'],
        ['userInfo', isPce ? 'pceUserInfo' : 'uniUserInfo', 'degree'],
        ['userInfo', isPce ? 'pceUserInfo' : 'uniUserInfo', 'university']
      ]
    },
    [EOnboaringFormStep.DEFINE_YOUR_GOAL_FP]: {
      requiredFields: [['userInfo', 'fpUserInfo', 'hasSubjectsToValidate']]
    },
    [EOnboaringFormStep.DEFINE_YOUR_GOAL_OPOS]: {
      requiredFields: [['userInfo', 'oposUserInfo', 'autonomousCommunity']]
    },
    [EOnboaringFormStep.YOUR_SITUATION]: {
      requiredFields: [
        ['userInfo', 'pceUserInfo', 'needVisa'],
        ['userInfo', 'pceUserInfo', 'hasCertificateDegree'],
        ['userInfo', 'pceUserInfo', 'hasNotesEquivalence']
      ]
    },
    [EOnboaringFormStep.PREPAIR_FOR_THE_CHALLENGE]: {
      requiredFields: [['userInfo', isPce ? 'pceUserInfo' : 'uniUserInfo', 'autonomousCommunity']]
    },
    [EOnboaringFormStep.SUBJECT_NOTES]: {
      requiredFields: [['userInfo', 'uniUserInfo', 'subjects']]
    },
    [EOnboaringFormStep.STUDY_PLAN]: {
      requiredFields: [['planification', 'endDate']]
    },
    [EOnboaringFormStep.CHOOSE_COURSES]: {
      requiredFields: [['planification', 'subscriptions']]
    },
    [EOnboaringFormStep.DISCOVER_SOURCES]: {
      requiredFields: [['onBoarding', 'discoverySource']]
    },
    [EOnboaringFormStep.CHOSEN_REASONS]: {
      requiredFields: [['onBoarding', 'chosenReason']]
    },
    [EOnboaringFormStep.FINAL_STEP]: {
      requiredFields: []
    }
  };
};
